if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.container = this.querySelector('[role="document"]');
        this.prevButton = this.querySelector('.product-media-modal__nav-button--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav-button--next');

        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', () => this.slide(-1));
          this.nextButton.addEventListener('click', () => this.slide(1));
          // Scroll-snap already fires this on swipe too, so buttons and
          // touch gestures both keep the disabled state in sync.
          this.container.addEventListener('scroll', this.updateNavButtons.bind(this));
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      slide(direction) {
        // 'smooth' here is silently ignored - confirmed live that
        // scroll-snap-type combined with JS smooth-scrolling (or even the
        // CSS scroll-behavior: smooth this container no longer has,
        // removed for the same reason) just doesn't animate on this
        // container, a known class of cross-browser scroll-snap bug.
        // Native touch swiping isn't affected (that's the browser's own
        // scroll physics, unrelated to this API), so only button/keyboard
        // navigation loses the animation - jumps straight to the next
        // slide instead.
        this.container.scrollBy({
          left: direction * this.container.clientWidth,
          behavior: 'instant',
        });
        // Don't rely solely on the container's 'scroll' event listener for
        // this - confirmed live it doesn't reliably fire after a
        // behavior: 'instant' scrollBy, leaving stale disabled states on
        // the buttons (next button never disabling at the last slide,
        // for example) until some unrelated scroll happened to fire it.
        this.updateNavButtons();
      }

      updateNavButtons() {
        if (!this.prevButton || !this.nextButton) return;
        // A couple of px of tolerance - scroll-snap doesn't always land on
        // an exact integer, especially after a fast swipe.
        const atStart = this.container.scrollLeft <= 2;
        const atEnd = this.container.scrollLeft >= this.container.scrollWidth - this.container.clientWidth - 2;
        this.prevButton.disabled = atStart;
        this.nextButton.disabled = atEnd;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // Jump straight to the clicked image's slide - no animation here
        // (this runs as the modal opens), matches the old
        // scrollIntoView()'s intent but along the new horizontal axis.
        // Must go through scrollTo(), not a direct scrollLeft assignment -
        // confirmed live that a raw property set is silently ignored on
        // this container (scroll-snap-type + scroll-behavior: smooth
        // together seem to only respect "real" scroll APIs, not a plain
        // property write, even one tested a full second later).
        this.container.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
        this.updateNavButtons();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
